import React from 'react';

import {Text, Anchor, NoDataMsg} from '@albert-io/atomic';
import appStore from 'client/AppStore';

interface EmptyUsageReportProps {
  headerText: string;
  bodyText?: string;
}

const EmptyUsageReport = ({headerText, bodyText}: EmptyUsageReportProps) => {
  return (
    <NoDataMsg.Container className='u-mar-t_6 u-display_flex u-align-items_center u-flex-direction_column u-text-align_center'>
      <NoDataMsg.Heading as='h1'>{headerText}</NoDataMsg.Heading>
      <NoDataMsg.Body className='u-mar-b_5 u-max-width_480'>
        {bodyText ? (
          <Text as='div' className='u-mar-b_2'>
            {bodyText}
          </Text>
        ) : null}
        <Text>
          Update your teacher list or invite new teachers by going to the{' '}
          <Anchor
            underlined
            to={`/school-admin/${appStore.routerProps.params.schoolId}/manage-staff/pending-approval`}
          >
            Manage Staff tab
          </Anchor>
          .
        </Text>
      </NoDataMsg.Body>
    </NoDataMsg.Container>
  );
};

export default EmptyUsageReport;
